import UnitInput from "../unit";
import ColorInput from "../color";
import "./style.scss";
import React, { useState } from "react";
import { PopoverAnchor, Popover, PopoverContent } from "..";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { INPUT_LIMITS } from "../../input-limits";

export default function SingleBoxShadow({
  value,
  onChange,
  onDelete,
  hideSpread = false,
}) {
  const [openPopOver, setOpenPopOver] = useState(false);

  return (
    <>
      <div className="cursor-default hover:bg-gray-50 p-2">
        <Popover>
          <PopoverAnchor
            placement="bottom"
            open={openPopOver}
            onOpenChange={setOpenPopOver}
          >
            <div className="grigora-singleborder__anchor flex items-center">
              <p>{`(${value.x} ${value.y} ${value.spread} ${value.blur} ${value.color})`}</p>
              <FontAwesomeIcon icon={faPen} className="p-2 cursor-pointer " />
              <FontAwesomeIcon
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete();
                }}
                icon={faTrash}
                className="p-2 cursor-pointer "
              />
            </div>
          </PopoverAnchor>
          <PopoverContent className="outline-none !z-[1000] !rounded-[6px] !bg-editor-light-main !shadow-editor-floating-elements">
            <div className="popover__content w-[250px] p-4 border">
              <UnitInput
                value={value.x}
                resetValue={""}
                isResetVisible={false}
                onChange={(e) => {
                  onChange({ ...value, x: e });
                }}
                label={"X"}
                minLength={INPUT_LIMITS["boxshadow-input"].minlength}
                maxLength={INPUT_LIMITS["boxshadow-input"].maxlength}
                isNegativeValid={true}
              />

              <UnitInput
                value={value.y}
                resetValue={""}
                isResetVisible={false}
                onChange={(e) => {
                  onChange({ ...value, y: e });
                }}
                label={"Y"}
                minLength={INPUT_LIMITS["boxshadow-input"].minlength}
                maxLength={INPUT_LIMITS["boxshadow-input"].maxlength}
                isNegativeValid={true}
              />
              {!hideSpread && (
                <UnitInput
                  value={value.spread}
                  resetValue={""}
                  isResetVisible={false}
                  onChange={(e) => {
                    onChange({ ...value, spread: e });
                  }}
                  maxLength={INPUT_LIMITS["boxshadow-input"].spread.maxlength}
                  minLength={INPUT_LIMITS["boxshadow-input"].spread.minlength}
                  label={"Blur"}
                />
              )}

              <UnitInput
                value={value.blur}
                resetValue={""}
                isResetVisible={false}
                onChange={(e) => {
                  onChange({ ...value, blur: e });
                }}
                maxLength={INPUT_LIMITS["boxshadow-input"].blur.maxlength}
                minLength={INPUT_LIMITS["boxshadow-input"].blur.minlength}
                label={"Spread"}
              />

              <ColorInput
                value={value.color}
                resetValue={""}
                isResetVisible={false}
                onChange={(e) => {
                  onChange({ ...value, color: e });
                }}
                label={"Color"}
              />
            </div>
          </PopoverContent>
        </Popover>
      </div>
    </>
  );
}
